import { PartnerDashboardDictionary } from 'types/i18n';
import { sharedDictionaryRu } from './sharedDictionaryRu';

export const partnerDashboardDictionaryRu: PartnerDashboardDictionary = {
  footer: {
    copyrightText() {
      const year = new Date().getFullYear();

      return `© ${year} Agmsoft`;
    },
  },
  header: {
    financesManagerActionText(balance) {
      return sharedDictionaryRu.moneyAmountText(balance, 'USD');
    },
    activeClientsLinkText: 'Активные клиенты',
    clientsCancelledLinkText: 'Бывшие клиенты',
    partnersCodeLabel: 'Ваш код партнера:',
    balanceLabel: 'Баланс:',
  },
};
